module.exports = __webpack_public_path__ + "img/iifl-logo.6604082c.png";